module.exports = __webpack_public_path__ + "static/media/electronic-security-boxes.106555af.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/electronic-security-boxes.png
// module id = 1288
// module chunks = 0